import { useId } from '@floating-ui/react';
import React, { HTMLProps, forwardRef } from 'react';

export interface VoxelSelectItemProps {
  children: React.ReactNode;
  active: boolean;
  selected: boolean;
  disabled?: boolean;
}

export const VoxelSelectItem = forwardRef<
  HTMLDivElement,
  VoxelSelectItemProps & HTMLProps<HTMLDivElement>
>(({ children, active, selected, disabled, className, ...rest }, ref) => {
  const id = useId();
  return (
    <div
      ref={ref}
      role="option"
      id={id}
      className={`
        ${selected && 'bg-voxel-gray-100'}
        ${active && !selected && 'bg-voxel-gray-50'}
        ${!active && !selected && !disabled && 'bg-white hover:bg-gray-50'}
        ${disabled ? 'opacity-50' : ''} 
        py-2 px-2.5 text-voxel-gray-700
        cursor-pointer
        rounded
        select-none
        ${className}
      `}
      {...rest}
    >
      {children}
    </div>
  );
});

export default VoxelSelectItem;
